import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  onSnapshot,
  query,
   deleteDoc, // 👈 أضف هذا
  orderBy,
  where,
  serverTimestamp,
  arrayUnion,
  getDocs,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebase"; // تأكد مسار firebase عندك
import { FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Timestamp } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { useBoxStaff } from "./utils/useBoxStaff";
/**
 * ✅ إعدادات بسيطة للمستخدم الحالي (حسب نظامكم)
 * عدّل أسماء الـ keys إذا مشروعك يستخدم أسماء مختلفة بالـ localStorage
 */
function getCurrentUser() {
  const username =
    localStorage.getItem("username") ||
    localStorage.getItem("user") ||
    "unknown";

  // إذا عندك role محفوظ باللوكال ستوري (admin / staff)
  const role =
    localStorage.getItem("role") ||
    (username === "admin" ? "admin" : "staff");

  return { username, role };
}

/**
 * ✅ قائمة الموظفات للاسناد AssignedTo
 * عدّلها حسب الأسماء الفعلية عندك
 */
const BASE_EMPLOYEES = [
  { name: "جمانا", username: "jumana@123" },
  { name: "بنين", username: "Baneen@123" },
 
  { name: "فرح", username: "farah@123" },

  { name: "مياسة", username: "maysa@123" },
];
const CUSTOMER_TYPE_LABELS = {
  project_hotel: "مشروع - فندق",
  project_restaurant: "مشروع - مطعم",
  project_cafe: "مشروع - كافيه",
  project_salon: "مشروع - صالون",
  project_clinic: "مشروع - عيادة",
  project_beauty_center: "مشروع - مركز تجميل",
  project_hospital: "مشروع - مستشفى",
  engineer_designer: "مهندس أو مصمم",
  engineering_company: "شركة هندسية او شركة تصميم داخلي",
  other_company: "شركات أخرى",
  apartment: "شقة",
  house: "بيت",
  influencer: "انفلونسر / بلوكر/مشهور",
  furniture_company: "شركة اثاث",
};

const SOURCE_LABELS = {
  "سوشال ميديا": "سوشال ميديا",
  "مجمع البروج - صروح A": "مجمع البروج - صروح A",
  "مجمع البروج - صروح D": "مجمع البروج - صروح D",
  "مجمع النسيم": "مجمع النسيم",
  "الريف كافيه - بغداد": "الريف كافيه - بغداد",
  "الريف كافيه - اربيل": "الريف كافيه - اربيل",
  "ارت تاتش": "ارت تاتش",
  "علاقات ومعارف": "علاقات ومعارف",
  "ميثم برحيه": "ميثم برحيه",
  "نواف": "نواف",
  "ست سارة": "ست سارة",
};
const TABS = [
  { key: "Pending", label: "🟡 Pending" },
  { key: "In Progress", label: "🔵 In Progress" },
  { key: "Converted", label: "🟢 Converted" },
  { key: "Closed", label: "🔴 Archive" },
   { key: "Site Visit", label: "🔥 Site Visit" },
];

const PRIORITIES = ["Low", "Medium", "High"];

// نفس خيارات إضافة الطلب (عدّلها إذا عندك قائمة ثابتة)
const CUSTOMER_TYPES = [
  { value: "project_hotel", label: "مشروع - فندق" },
  { value: "project_restaurant", label: "مشروع - مطعم" },
  { value: "project_cafe", label: "مشروع - كافيه" },
  { value: "project_salon", label: "مشروع - صالون" },
  { value: "project_clinic", label: "مشروع - عيادة" },
  { value: "project_beauty_center", label: "مشروع - مركز تجميل" },
  { value: "project_hospital", label: "مشروع - مستشفى" },
  { value: "engineer_designer", label: "مهندس أو مصمم" },
  { value: "engineering_company", label: "شركة هندسية" },
  { value: "other_company", label: "شركات أخرى" },
  { value: "apartment", label: "شقة" },
  { value: "house", label: "بيت" },
  { value: "influencer", label: "انفلونسر / بلوكر / مشهور" },
  { value: "furniture_company", label: "شركة اثاث" },
];

const SOURCES = [
  { value: "سوشال ميديا", label: "سوشال ميديا" },
  { value: "مجمع البروج - صروح A", label: "مجمع البروج - صروح A" },
  { value: "مجمع البروج - صروح D", label: "مجمع البروج - صروح D" },
  { value: "مجمع النسيم", label: "مجمع النسيم" },
  { value: "الريف كافيه - بغداد", label: "الريف كافيه - بغداد" },
  { value: "الريف كافيه - اربيل", label: "الريف كافيه - اربيل" },
  { value: "ارت تاتش", label: "ارت تاتش" },
  { value: "علاقات ومعارف", label: "علاقات ومعارف" },
  { value: "ميثم برحيه", label: "علاقات ومعارف – ميثم برحيه" },
  { value: "نواف", label: "علاقات ومعارف – نواف" },
  { value: "ست سارة", label: "ست سارة" },
];
const GOVERNORATES = [
  "بغداد",
  "البصرة",
  "نينوى",
  "الأنبار",
  "ديالى",
  "كركوك",
  "واسط",
  "ميسان",
  "ذي قار",
  "بابل",
  "كربلاء",
  "النجف",
  "الديوانية",
  "المثنى",
  "صلاح الدين",
  "دهوك",
  "أربيل",
  "السليمانية",
];


function formatTime(ts) {
  try {
    if (!ts) return "-";
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString("ar-IQ");
  } catch {
    return "-";
  }
}

function classByStatus(status) {
  if (status === "Pending") return { border: "#f5c542", bg: "#fff8e1" };
  if (status === "In Progress") return { border: "#3b82f6", bg: "#eff6ff" };
  if (status === "Converted") return { border: "#22c55e", bg: "#ecfdf5" };
  if (status === "Closed") return { border: "#ef4444", bg: "#fef2f2" };
  return { border: "#ddd", bg: "#fff" };
}

export default function LeadsDashboard() {
  // + موظفات البوكسات (الحسابات الجديدة مثل تيهان) تلقائياً للإسناد
  const boxStaff = useBoxStaff();
  const EMPLOYEES = [
    ...BASE_EMPLOYEES,
    ...boxStaff.map((s) => ({ name: s.displayName, username: s.username })),
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const { username, role } = useMemo(() => getCurrentUser(), []);
const [otherCustomerType, setOtherCustomerType] = useState("");

  const isAdmin = role === "admin";

  const [activeTab, setActiveTab] = useState("Pending");
  const [allLeads, setAllLeads] = useState([]);

  // مودالات
  
  const [openConvert, setOpenConvert] = useState(false);

  // Lead selected
  const [selectedLead, setSelectedLead] = useState(null);

  // إضافة lead
  const [form, setForm] = useState({
    customerName: "",
    companyName: "",
     phone: "", // ✅ هذا الجديد
    facebook: "",
    instagram: "",
    website: "",
    customerType: "",
    source: "",
    governorate: "",
    location: "",
      attachmentLink: "", // ✅ رابط بدل الملفات
    description: "",
    priority: "Medium",
  });
 const [openAdd, setOpenAdd] = useState(false);
useEffect(() => {
  if (location.state?.fromVisit && location.state?.leadData) {
setForm({
  customerName: location.state.leadData.customerName || "",
  companyName: location.state.leadData.companyName || "",
  phone: location.state.leadData.phone || "",
  facebook: location.state.leadData.facebook || "",
  instagram: location.state.leadData.instagram || "",
  website: location.state.leadData.website || "",
  customerType: location.state.leadData.customerType || "",
  source: location.state.leadData.source || "زيارة موقع",
  governorate: location.state.leadData.governorate || "",
  location: location.state.leadData.location || "",
  description: location.state.leadData.description || "",
  attachmentLink: location.state.leadData.attachmentLink || "",
  priority: location.state.leadData.priority || "Medium",
});

    setOpenAdd(true);
  }
}, [location.state]);





  const [saving, setSaving] = useState(false);

  // تعليقات
  const [commentText, setCommentText] = useState("");
  const [commentSaving, setCommentSaving] = useState(false);
const [openReassign, setOpenReassign] = useState(false);
const [newAssignee, setNewAssignee] = useState("");
const [editingLeadId, setEditingLeadId] = useState(null);
const [selectedEmployee, setSelectedEmployee] = useState("all");
  // مرفقات
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  // ====== تحميل Leads (Realtime) ======
  useEffect(() => {
    const q = query(collection(db, "leads"), orderBy("createdAt", "desc"));

    const unsub = onSnapshot(q, async (snap) => {
      const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      // فلترة الصلاحيات:
      // - Admin: الكل
      // - Staff: createdBy == username OR assignedTo == username
   let filtered;

if (isAdmin) {
  if (selectedEmployee === "all") {
    filtered = docs;
  } else {
    filtered = docs.filter(
      (x) => x.assignedTo === selectedEmployee
    );
  }
} else {
  filtered = docs.filter((x) => x.assignedTo === username);
}

      setAllLeads(filtered);
    });

    return () => unsub();
 }, [isAdmin, username, selectedEmployee]);
useEffect(() => {
  if (!selectedLead) return;

  const updated = allLeads.find(l => l.id === selectedLead.id);
  if (updated) {
    setSelectedLead(updated);
  }
}, [allLeads]);

 const leadsByTab = useMemo(() => {
  if (activeTab === "Site Visit") {
    return allLeads.filter((l) => l?.sourceType === "site_visit");
  }

  return allLeads.filter((l) => (l.status || "Pending") === activeTab);
}, [allLeads, activeTab]);

  // ====== Helpers ======
 function resetForm() {
  setForm({
    customerName: "",
    companyName: "",
    facebook: "",
    instagram: "",
    website: "",
    customerType: "",
    source: "",
    governorate: "",
    location: "",
    description: "",
    attachmentLink: "",
    priority: "Medium",
  });
}

  function openDetails(lead) {
    setSelectedLead(lead);
    setCommentText("");
  }

  // ====== Upload Files to Storage ======
 

  // ====== Add Lead ======
  async function handleAddLead() {
    // Validations
 
    if (!form.customerName.trim()) {
      alert("اسم الزبون إجباري");
      return;
    }
    if (!form.phone.trim()) {
  alert("رقم الهاتف إجباري");
  return;
}
if (!form.attachmentLink.trim()) {
  alert("رابط OneDrive إجباري");
  return;
}

if (!form.description.trim()) {
  alert("الوصف / المطلوب إجباري");
  return;
}

    if (!form.customerType) {
      alert("نوع الزبون إجباري");
      return;
    }
    if (!form.source) {
      alert("مصدر الزبون إجباري");
      return;
    }
    if (!form.governorate) {
      alert("المحافظة إجباري");
      return;
    }
  

    setSaving(true);
    try {

      // 1) Create lead without attachments first
   if (editingLeadId) {

  await updateDoc(doc(db, "leads", editingLeadId), {
    customerName: form.customerName.trim(),
    companyName: form.companyName.trim(),
    facebook: form.facebook.trim(),
    instagram: form.instagram.trim(),
    website: form.website.trim(),
    customerType: form.customerType,
    source: form.source,
    governorate: form.governorate,
    location: form.location.trim(),
    description: form.description.trim(),
    attachmentLink: form.attachmentLink.trim(),
    priority: form.priority,
    phone: form.phone.trim(),
    updatedAt: serverTimestamp(),
  });

  alert("✅ تم تعديل الزبون المحتمل");

} else {

  await addDoc(collection(db, "leads"), {
    customerName: form.customerName.trim(),
    companyName: form.companyName.trim(),
    facebook: form.facebook.trim(),
    instagram: form.instagram.trim(),
    website: form.website.trim(),
    customerType: form.customerType,
    source: form.source,
    governorate: form.governorate,
    location: form.location.trim(),
    description: form.description.trim(),
    attachmentLink: form.attachmentLink.trim(),
    createdBy: username,
    assignedTo: username,
    priority: form.priority,
    status: "Pending",
    converted: false,
    attachments: [],
    phone: form.phone.trim(),
    comments: {},
    createdAt: serverTimestamp(),
     sourceType: "site_visit", // نستخدم هذا الحقل لنعرف أن هذا الـ lead جاء من زيارة موقع
  });

  alert("✅ تم إضافة الزبون المحتمل");

}
      // 2) Upload attachments then update lead
    

      setOpenAdd(false);
        setEditingLeadId(null);
      resetForm();
      alert("✅ تم إضافة الزبون المحتمل بنجاح");
    } catch (e) {
      console.error(e);
      alert("صار خطأ أثناء الحفظ");
    } finally {
      setSaving(false);
    }
  }

  // ====== Status Updates ======
  async function updateStatus(leadId, nextStatus) {
    try {
      await updateDoc(doc(db, "leads", leadId), {
        status: nextStatus,
        statusUpdatedAt: serverTimestamp(),
      });
    } catch (e) {
      console.error(e);
      alert("تعذر تحديث الحالة");
    }
  }
async function handleDeleteLead(leadId) {
  try {
    const confirmDelete = window.confirm("❗ هل أنت متأكد من حذف هذا الزبون المحتمل؟");
    if (!confirmDelete) return;

    await deleteDoc(doc(db, "leads", leadId));

    setSelectedLead(null); // حتى ما يبقى ظاهر بعد الحذف

    alert("🗑️ تم حذف الزبون المحتمل");
  } catch (e) {
    console.error(e);
    alert("صار خطأ أثناء الحذف");
  }
}
  // ====== Add Comment ======
async function addComment() {
  if (!selectedLead?.id) return;
  if (!commentText.trim()) return;

  setCommentSaving(true);

  try {
    await updateDoc(doc(db, "leads", selectedLead.id), {
      [`comments.${username}`]: arrayUnion({
        text: commentText.trim(),
        timestamp: Timestamp.now(),
      }),
    });

    setCommentText("");
  } catch (e) {
    console.error("COMMENT ERROR:", e);
    alert("صار خطأ: " + e.message);
  } finally {
    setCommentSaving(false);
  }
}

  // ====== Convert Lead (Confirm then Navigate) ======
  function askConvert(lead) {
    setSelectedLead(lead);
    setOpenConvert(true);
  }

  function confirmConvert() {
    if (!selectedLead?.id) return;

    // نفتح AddOrder ونمرر بيانات الـ lead
  navigate("/add", {

      state: {
        fromLead: true,
        leadId: selectedLead.id,
        leadData: {
          customerName: selectedLead.customerName || "",
          companyName: selectedLead.companyName || "",
          governorate: selectedLead.governorate || "",
          customerType: selectedLead.customerType || "",
          source: selectedLead.source || "",
          location: selectedLead.location || "",
          description: selectedLead.description || "",
          facebook: selectedLead.facebook || "",
          instagram: selectedLead.instagram || "",
          website: selectedLead.website || "",
        },
      },
    });

    setOpenConvert(false);
  }
const hideSocialFields =
  form.customerType === "house" ||
  form.customerType === "apartment";
  // ====== UI ======
  return (
    <div style={{ padding: 16, direction: "rtl", maxWidth: 1100, margin: "0 auto" }}>
      <header
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginBottom: 14,
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>📌 الزبائن المحتملين</h2>
          <div style={{ fontSize: 13, opacity: 0.8 }}>
            المستخدم: <b>{username}</b> | الصلاحية:{" "}
            <b>{isAdmin ? "مدير" : "موظف"}</b>
          </div>
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          <button
            onClick={() => setOpenAdd(true)}
            style={btnPrimary}
          >
            ➕ إضافة زبون محتمل
          </button>

          <button
            onClick={() => navigate(-1)}
            style={btn}
          >
            ⬅️ رجوع
          </button>
        </div>
      </header>
{/* 🔥 فلتر الموظفات */}
{isAdmin && (
  <FormControl sx={{ mb: 2, minWidth: 250 }}>
    <InputLabel>اختيار الموظفة</InputLabel>
    <Select
      value={selectedEmployee}
      label="اختيار الموظفة"
      onChange={(e) => setSelectedEmployee(e.target.value)}
    >
      <MenuItem value="all">الكل</MenuItem>

      {EMPLOYEES.map((emp) => (
        <MenuItem key={emp.username} value={emp.username}>
          {emp.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)}
      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key)}
            style={{
              ...btn,
              border:
                activeTab === t.key ? "2px solid #111" : "1px solid #ddd",
              background: activeTab === t.key ? "#111" : "#fff",
              color: activeTab === t.key ? "#fff" : "#111",
            }}
          >
            {t.label} ({
t.key === "Site Visit"
  ? allLeads.filter((x) => x?.sourceType === "site_visit").length
  : allLeads.filter((x) => (x.status || "Pending") === t.key).length
})
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {/* Left: list */}
        <div>
          {leadsByTab.length === 0 ? (
            <div style={emptyBox}>لا يوجد عناصر بهذا التاب</div>
          ) : (
            leadsByTab.map((lead) => {
              const st = classByStatus(lead.status);
              return (
                <div
                  key={lead.id}
                  onClick={() => openDetails(lead)}
                  style={{
                    cursor: "pointer",
                    border: `2px solid ${st.border}`,
                    background: st.bg,
                    borderRadius: 12,
                    padding: 12,
                    marginBottom: 10,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                    <div style={{ fontWeight: 800, fontSize: 16 }}>
                      {lead.customerName || "-"}
                    </div>
                    <div style={{ fontSize: 12, opacity: 0.75 }}>
                      {formatTime(lead.createdAt)}
                    </div>
                  </div>
{lead?.sourceType=== "site_visit" && (
  <div style={{
    background: "#0ea5e9",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: 8,
    fontSize: 12,
    display: "inline-block",
    marginBottom: 6,
    fontWeight: "bold"
  }}>
    🔥 Site Visit
  </div>
)}
                  <div style={{ marginTop: 6, fontSize: 13, opacity: 0.9, lineHeight: 1.6 }}>
                    <div>🏢 الشركة: <b>{lead.companyName || "—"}</b></div>
                    <div>📍 المحافظة: <b>{lead.governorate || "—"}</b></div>
                   <div>🏷️ النوع: <b>{CUSTOMER_TYPE_LABELS[lead?.customerType] || "—"}</b></div>
<div>🧲 المصدر: <b>{SOURCE_LABELS[lead?.source] || "—"}</b></div>
                    <div>⚡ الأولوية: <b>{lead.priority || "—"}</b></div>
                    <div>📩 من: <b>{lead.createdBy || "—"}</b> → إلى: <b>{lead.assignedTo || "—"}</b></div>
                  </div>

                  {lead.converted ? (
                    <div style={{ marginTop: 8, fontSize: 13, fontWeight: 800, color: "#15803d" }}>
                      ✅ تم التحويل إلى زبون حقيقي
                    </div>
                  ) : null}
                </div>
              );
            })
          )}
        </div>

        {/* Right: details */}
        <div style={detailsBox}>
          {!selectedLead ? (
            <div style={{ opacity: 0.8 }}>اختر زبون محتمل من القائمة لعرض التفاصيل</div>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 900 }}>
                    {selectedLead.customerName}
                  </div>
                  <div style={{ fontSize: 13, opacity: 0.8 }}>
                    🕒 {formatTime(selectedLead.createdAt)} | الحالة:{" "}
                    <b>{selectedLead.status}</b>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
  style={{ ...btn, border: "1px solid #2563eb" }}
  onClick={() => {
    setForm({
      customerName: selectedLead.customerName || "",
      companyName: selectedLead.companyName || "",
      facebook: selectedLead.facebook || "",
      instagram: selectedLead.instagram || "",
      website: selectedLead.website || "",
      customerType: selectedLead.customerType || "",
      source: selectedLead.source || "",
      governorate: selectedLead.governorate || "",
      location: selectedLead.location || "",
      description: selectedLead.description || "",
      attachmentLink: selectedLead.attachmentLink || "",
      priority: selectedLead.priority || "Medium",
    });

    setOpenAdd(true); // نفس مودال الإضافة
  }}
>
✏️ تعديل
</button>
                  {selectedLead.status === "Pending" && (
                    <button
                      style={btnPrimary}
                      onClick={() => updateStatus(selectedLead.id, "In Progress")}
                    >
                      🔵 بدأ العمل
                    </button>
                  )}
<button
  style={{ ...btn, border: "1px solid #8b5cf6" }}
  onClick={() => {
    setNewAssignee(selectedLead.assignedTo || "");
    setOpenReassign(true);
  }}
>
  🔁 تحويل لموظف آخر
</button>

                  {selectedLead.status === "In Progress" && (
                    <button
                      style={btn}
                      onClick={() => updateStatus(selectedLead.id, "Pending")}
                    >
                      ⬅️ رجعه Pending
                    </button>
                  )}

                  {!selectedLead.converted && (
                    <button
                      style={{ ...btn, border: "1px solid #22c55e" }}
                      onClick={() => askConvert(selectedLead)}
                      disabled={selectedLead.status === "Closed"}
                    >
                      🔄 تحويل إلى طلب
                    </button>
                  )}

                  {selectedLead.status !== "Closed" && (
                    <button
                      style={{ ...btn, border: "1px solid #ef4444" }}
                      onClick={() => updateStatus(selectedLead.id, "Closed")}
                    >
                      📦 أرشفة
                    </button>
                  )} 
                  {isAdmin && (
  <button
    style={{ ...btn, border: "1px solid #dc2626", color: "#dc2626" }}
    onClick={() => handleDeleteLead(selectedLead.id)}
  >
    🗑️ حذف
  </button>
)}
                </div>
              </div>

              <hr style={{ margin: "12px 0" }} />

              <div style={{ lineHeight: 1.8, fontSize: 14 }}>
                <div>🏢 الشركة: <b>{selectedLead.companyName || "—"}</b></div>
              <div>🏷️ النوع: <b>{CUSTOMER_TYPE_LABELS[selectedLead?.customerType] || "—"}</b></div>
<div>🧲 المصدر: <b>{SOURCE_LABELS[selectedLead?.source] || "—"}</b></div>
                <div>📍 المحافظة: <b>{selectedLead.governorate || "—"}</b></div>
                <div>📌 الموقع: <b>{selectedLead.location || "—"}</b></div>
                {selectedLead.attachmentLink ? (
  <div style={{ marginTop: 8 }}>
    🔗 رابط المرفق:{" "}
    <a
      href={selectedLead.attachmentLink}
      target="_blank"
      rel="noreferrer"
      style={{ color: "#2563eb", fontWeight: 700 }}
    >
      فتح الرابط
    </a>
  </div>
) : null}
                <div>👤 من: <b>{selectedLead.createdBy || "—"}</b></div>
                <div>🎯 المسؤول:<b>
  {EMPLOYEES.find(e => e.username === selectedLead.assignedTo)?.name || "—"}
</b>
</div>

                {selectedLead.facebook ? (
                  <div>📘 فيسبوك: <a href={selectedLead.facebook} target="_blank" rel="noreferrer">{selectedLead.facebook}</a></div>
                ) : null}
                {selectedLead.instagram ? (
                  <div>📷 انستغرام: <a href={selectedLead.instagram} target="_blank" rel="noreferrer">{selectedLead.instagram}</a></div>
                ) : null}
                {selectedLead.website ? (
                  <div>🌐 ويبسايت: <a href={selectedLead.website} target="_blank" rel="noreferrer">{selectedLead.website}</a></div>
                ) : null}

                <div style={{ marginTop: 10 }}>
                  📝 المطلوب/الوصف:
                  <div style={noteBox}>
                    {selectedLead.description || "—"}
                  </div>
                </div>
              </div>

              {/* Attachments */}
              <div style={{ marginTop: 12 }}>
                <div style={{ fontWeight: 900, marginBottom: 6 }}>📎 المرفقات</div>
                {Array.isArray(selectedLead.attachments) && selectedLead.attachments.length > 0 ? (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {selectedLead.attachments.map((a, idx) => (
                      <Attachment key={idx} a={a} />
                    ))}
                  </div>
                ) : (
                  <div style={{ opacity: 0.7 }}>لا توجد مرفقات</div>
                )}
              </div>
{/* Comments */}
<div style={{ marginTop: 16 }}>
  <div style={{ fontWeight: 900, marginBottom: 8 }}>💬 التعليقات</div>

  {/* صندوق كتابة التعليق */}
  <div style={{ display: "flex", gap: 8 }}>
    <textarea
      value={commentText}
      onChange={(e) => setCommentText(e.target.value)}
      placeholder="اكتب تعليق..."
      style={textarea}
      rows={2}
      disabled={selectedLead.status === "Closed"}
    />
    <button
      onClick={addComment}
      style={btnPrimary}
      disabled={
        commentSaving ||
        !commentText.trim() ||
        selectedLead.status === "Closed"
      }
    >
      {commentSaving ? "..." : "إرسال"}
    </button>
  </div>

  {/* عرض التعليقات */}
  <div style={{ marginTop: 12 }}>
    {(() => {
      const myComments = selectedLead?.comments?.[username] || [];

      return myComments.length > 0 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {myComments
            .slice()
            .sort((a, b) => {
              const ta = a?.timestamp?.seconds || 0;
              const tb = b?.timestamp?.seconds || 0;
              return ta - tb;
            })
            .map((c, i) => (
              <div key={i} style={commentCard}>
                <div style={{ fontSize: 12, opacity: 0.75 }}>
                  {formatTime(c.timestamp)}
                </div>
                <div style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>
                  {c.text}
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div style={{ opacity: 0.7 }}>لا توجد تعليقات بعد</div>
      );
    })()}
  </div>
</div>

                <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
              </div>
            </>
          )}
        </div>
      </div>

      {/* ============ Add Lead Modal ============ */}
      {openAdd && (
        <Modal title="➕ إضافة زبون محتمل" onClose={() => { setOpenAdd(false); resetForm(); }}>
      <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
  }}
>

  {/* اسم + هاتف */}
  <TextField
    fullWidth
    label="اسم الزبون *"
    value={form.customerName}
    onChange={(e) => setForm({ ...form, customerName: e.target.value })}
    size="small"
    required
  />

<TextField
  fullWidth
  label="رقم الهاتف *"
  value={form.phone}
  onChange={(e) => {
    const value = e.target.value;

    // 🔥 يسمح فقط بالأرقام
    if (/^\d*$/.test(value)) {
      setForm({ ...form, phone: value });
    }
  }}
  size="small"
  required
  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
/>

  {/* شركة + نوع */}
  <TextField
    fullWidth
    label="اسم الشركة"
    value={form.companyName}
    onChange={(e) => setForm({ ...form, companyName: e.target.value })}
    size="small"
  />

  <FormControl fullWidth size="small">
    <InputLabel>نوع الزبون *</InputLabel>
    <Select
      value={form.customerType}
      label="نوع الزبون *"
     onChange={(e) => {
  const value = e.target.value;

  setForm((p) => ({
    ...p,
    customerType: value,
    ...(value === "house" || value === "apartment"
      ? { facebook: "", instagram: "", website: "" }
      : {}),
  }));

  setOtherCustomerType("");
}}
    >
    {CUSTOMER_TYPES.map((item) => (
  <MenuItem key={item.value} value={item.value}>
    {item.label}
  </MenuItem>
))}
    </Select>
  </FormControl>

  {/* حقل شركات اخرى */}
  {form.customerType === "other_company" && (
    <div style={{ gridColumn: "1 / -1" }}>
      <TextField
        fullWidth
        label="اذكر نوع الزبون"
        value={otherCustomerType}
        onChange={(e) => setOtherCustomerType(e.target.value)}
        size="small"
        required
      />
    </div>
  )}

  {/* محافظة + مصدر */}
  <FormControl fullWidth size="small">
    <InputLabel>المحافظة *</InputLabel>
    <Select
      value={form.governorate}
      label="المحافظة *"
      onChange={(e) =>
        setForm({ ...form, governorate: e.target.value })
      }
    >
      {GOVERNORATES.map((gov) => (
        <MenuItem key={gov} value={gov}>
          {gov}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <FormControl fullWidth size="small">
    <InputLabel>مصدر الزبون *</InputLabel>
    <Select
      value={form.source}
      label="مصدر الزبون *"
      onChange={(e) =>
        setForm({ ...form, source: e.target.value })
      }
    >
    {SOURCES.map((item) => (
  <MenuItem key={item.value} value={item.value}>
    {item.label}
  </MenuItem>
))}
    </Select>
  </FormControl>

  {/* موقع */}
  <TextField
    fullWidth
    label="عنوان الزبون بالتفصيل"
    value={form.location}
    onChange={(e) => setForm({ ...form, location: e.target.value })}
    size="small"
  />

  {/* فيسبوك + انستا */}
  {!hideSocialFields && (
     <>
  <TextField
    fullWidth
    label="Facebook"
    value={form.facebook}
    onChange={(e) => setForm({ ...form, facebook: e.target.value })}
    size="small"
  />

  <TextField
    fullWidth
    label="Instagram"
    value={form.instagram}
    onChange={(e) => setForm({ ...form, instagram: e.target.value })}
    size="small"
  />


    <TextField
      fullWidth
      label="Website"
      value={form.website}
      onChange={(e) => setForm({ ...form, website: e.target.value })}
      size="small"
    />
 
 </>
)}

  {/* رابط */}
    <TextField
      fullWidth
      label="رابط OneDrive"
      value={form.attachmentLink}
      onChange={(e) =>
        setForm({ ...form, attachmentLink: e.target.value })
      }
      size="small"
    />
  
  {/* الأولوية */}
  <FormControl fullWidth size="small">
    <InputLabel>الأولوية</InputLabel>
    <Select
      value={form.priority}
      label="الأولوية"
      onChange={(e) =>
        setForm({ ...form, priority: e.target.value })
      }
    >
      {PRIORITIES.map((p) => (
        <MenuItem key={p} value={p}>
          {p}
        </MenuItem>
      ))}
    </Select>
  </FormControl>







  {/* الوصف */}
  <div style={{ gridColumn: "1 / -1" }}>
    <TextField
      fullWidth
      label="الوصف / المطلوب"
      value={form.description}
      onChange={(e) => setForm({ ...form, description: e.target.value })}
      multiline
      rows={4}
      size="small"
    />
  </div>



</div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 14 }}>
            <button
              onClick={() => { setOpenAdd(false); resetForm(); }}
              style={btn}
              disabled={saving || uploading}
            >
              إلغاء
            </button>
            <button
              onClick={handleAddLead}
              style={btnPrimary}
              disabled={saving || uploading}
            >
              {saving || uploading ? "جاري الحفظ..." : "حفظ"}
            </button>
          </div>
        </Modal>
      )}

      {/* ============ Convert Confirm Modal ============ */}
      {openConvert && selectedLead && (
        <Modal
          title="🔄 تأكيد التحويل إلى طلب"
          onClose={() => setOpenConvert(false)}
        >
          <div style={{ lineHeight: 1.8 }}>
            هل أنت متأكد تريد تحويل هذا الزبون المحتمل إلى طلب رسمي؟
            <div style={{ marginTop: 10, padding: 10, background: "#f7f7f7", borderRadius: 10 }}>
              <div><b>الزبون:</b> {selectedLead.customerName}</div>
              <div><b>رقم الهاتف:</b> {selectedLead.phone || "—"}</div>
              <div><b>المحافظة:</b> {selectedLead.governorate || "—"}</div>
              <div><b>النوع:</b> {selectedLead.customerType || "—"}</div>
              <div><b>المصدر:</b> {selectedLead.source || "—"}</div>
            </div>
            <div style={{ marginTop: 10, fontSize: 13, opacity: 0.8 }}>
              بعد التحويل راح تنفتح صفحة إضافة الطلب ومعبّيّة المعلومات تلقائيًا.
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 14 }}>
            <button style={btn} onClick={() => setOpenConvert(false)}>
              إلغاء
            </button>
            <button style={btnPrimary} onClick={confirmConvert}>
              ✅ نعم تحويل
            </button>
          </div>
        </Modal>
      )}

      {openReassign && selectedLead && (
  <Modal
    title="🔁 تحويل الزبون المحتمل"
    onClose={() => setOpenReassign(false)}
  >
    <FormControl fullWidth>
      <InputLabel>اختر الموظف الجديد</InputLabel>
      <Select
        value={newAssignee}
        label="اختر الموظف الجديد"
        onChange={(e) => setNewAssignee(e.target.value)}
      >
       {EMPLOYEES.map((emp) => (
  <MenuItem key={emp.username} value={emp.username}>
    {emp.name}
  </MenuItem>
))}

      </Select>
    </FormControl>

    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
      <button style={btn} onClick={() => setOpenReassign(false)}>
        إلغاء
      </button>

    <button
  style={btnPrimary}
  onClick={async () => {
    try {
      if (!newAssignee) {
        alert("اختاري موظف أولاً");
        return;
      }

      if (!selectedLead?.id) {
        alert("ماكو Lead محدد");
        return;
      }

      console.log("Updating lead:", selectedLead.id, newAssignee);

      await updateDoc(doc(db, "leads", selectedLead.id), {
        assignedTo: newAssignee,
        reassignedAt: serverTimestamp(),
      });

      alert("✅ تم التحويل بنجاح");

      setOpenReassign(false);
    } catch (error) {
      console.error("ERROR:", error);
      alert("صار خطأ: " + error.message);
    }
  }}
>
  ✅ تأكيد التحويل
</button>

    </div>
  </Modal>
)}

    </div>
  );
}

/* ================== UI Components ================== */

function Modal({ title, onClose, children }) {
  return (
    <div style={modalOverlay} onMouseDown={onClose}>
      <div style={modalBox} onMouseDown={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
          <div style={{ fontWeight: 900 }}>{title}</div>
          <button onClick={onClose} style={btn}>
            ✖️
          </button>
        </div>
        <div style={{ marginTop: 12 }}>{children}</div>
      </div>
    </div>
  );
}

function Input({ label, value, onChange }) {
  return (
    <div style={{ width: "100%" }}>
      <label style={labelStyle}>{label}</label>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={inputStyle}
      />
    </div>
  );
}


function Attachment({ a }) {
  if (a.type === "image") {
    return (
      <a href={a.url} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
        <img
          src={a.url}
          alt={a.name}
          style={{ width: 90, height: 90, objectFit: "cover", borderRadius: 10, border: "1px solid #ddd" }}
        />
        <div style={{ width: 90, fontSize: 11, opacity: 0.75, marginTop: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {a.name}
        </div>
      </a>
    );
  }
  if (a.type === "video") {
    return (
      <a href={a.url} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
        <div style={{ width: 180 }}>
          <video src={a.url} controls style={{ width: 180, borderRadius: 10, border: "1px solid #ddd" }} />
          <div style={{ fontSize: 11, opacity: 0.75, marginTop: 4 }}>
            {a.name}
          </div>
        </div>
      </a>
    );
  }
  return (
    <a href={a.url} target="_blank" rel="noreferrer" style={{ ...fileChip }}>
      📄 {a.name}
    </a>
  );
}

/* ================== Styles ================== */

const btn = {
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #ddd",
  background: "#fff",
  cursor: "pointer",
  fontWeight: 700,
};

const btnPrimary = {
  ...btn,
  border: "1px solid #111",
  background: "#111",
  color: "#fff",
};

const detailsBox = {
  border: "1px solid #ddd",
  borderRadius: 12,
  padding: 12,
  background: "#fff",
  minHeight: 320,
};

const emptyBox = {
  border: "1px dashed #ccc",
  borderRadius: 12,
  padding: 16,
  background: "#fafafa",
  opacity: 0.9,
};

const noteBox = {
  marginTop: 6,
  background: "#f7f7f7",
  border: "1px solid #eee",
  borderRadius: 10,
  padding: 10,
  whiteSpace: "pre-wrap",
};

const commentCard = {
  border: "1px solid #eee",
  borderRadius: 10,
  padding: 10,
  background: "#fafafa",
};

const inputStyle = {
  width: "100%",
  padding: "10px 10px",
  borderRadius: 10,
  border: "1px solid #ddd",
  outline: "none",
};

const textarea = {
  width: "100%",
  padding: "10px 10px",
  borderRadius: 10,
  border: "1px solid #ddd",
  outline: "none",
  resize: "vertical",
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  marginBottom: 6,
  opacity: 0.85,
};

const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 12,
zIndex: 1300,
};

const modalBox = {
  width: "min(900px, 96vw)",
  maxHeight: "90vh",
  overflow: "auto",
  background: "#fff",
  borderRadius: 14,
  padding: 14,
  border: "1px solid #eee",
};

const fileChip = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "10px 12px",
  border: "1px solid #ddd",
  borderRadius: 10,
  background: "#fff",
  color: "#111",
  fontWeight: 700,
};
